import { formatCentsWithCurrency } from "@/lib/formatting/currency";

export function RangeBar({
  lowCents,
  highCents,
  valueCents,
  currency,
  label,
}: {
  lowCents: number;
  highCents: number;
  valueCents: number;
  currency: "USD" | "CAD";
  label: string;
}) {
  const span = highCents - lowCents;
  const position =
    span > 0 ? Math.min(100, Math.max(0, ((valueCents - lowCents) / span) * 100)) : 50;
  return (
    <div className="min-w-0">
      <p className="text-xs font-medium text-fg-muted">{label}</p>
      <div className="relative mt-3 h-1.5 rounded-full bg-border-subtle">
        <span
          aria-hidden
          className="absolute top-1/2 h-3.5 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-accent"
          style={{ left: `${position}%` }}
        />
      </div>
      <p className="mt-1.5 flex justify-between tabular-nums text-xs text-fg-muted">
        <span>{formatCentsWithCurrency(lowCents, currency)}</span>
        <span>{formatCentsWithCurrency(highCents, currency)}</span>
      </p>
    </div>
  );
}
